import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import importApi from '../api/importApi';

export const uploadImport = createAsyncThunk(
  'importer/upload',
  async ({ type, file }, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append('type', type);
      formData.append('file', file);

      const res = await importApi.upload(formData);
      return res?.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const importSlice = createSlice({
  name: 'importer',
  initialState: {
    loading: false,
    error: null,
    success: false,
    data: null
  },
  reducers: {
    resetImportState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadImport.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(uploadImport.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(uploadImport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Upload failed';
        state.success = false;
      });
  }
});

export const { resetImportState } = importSlice.actions;
export default importSlice.reducer;
